import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Route, Redirect } from 'react-router';

import {
  TextField,
} from '../components';
import { ThemeImages, ThemeColors } from '../theme';
import { withStyles } from '@material-ui/styles';
import Login from './login';
import Signup from './signup';
import SlamLogo from '../../images/slam/logo_slam.png';
import SlamLogoUncut from '../../images/slam/logo_slam_uncut.png';
import Typography from '@material-ui/core/Typography';

class LoginSignupWrapper extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }


  render() {
    const { classes } = this.props;

    const titleContainer = {
      position: 'absolute',
      top: '20vh',
      left: '5vw',
      color: 'white',
    };

    const titleStyle = {
      fontSize: '4em',
      fontWeight: 'bold',
    };

    const subTitleStyle = {
      fontSize: '1.5em',
    };


    return (
      <Grid container className={classes.containerGrid}>
        <Grid item xs={0} sm={8} xl={9} >
          <div className={classes.imageContainerGrid} style={this.props.imageContainerStyle}>
            <div style={titleContainer}>
              <Typography style={titleStyle}>{this.props.title}</Typography>
              <Typography style={subTitleStyle}>{this.props.subtitle}</Typography>
            </div>
            <img src={SlamLogo} style={{ maxwidth: '50vw', maxHeight: '50vh' }} />
          </div>
        </Grid>

        <Grid item xs={12} sm={4} xl={3} >
          <div className={classes.logoContainer}>
            <img src={SlamLogoUncut} alt="Logo" className={classes.logo} />
          </div>
          {this.props.children}
          {/* <Route path="/platform/login" component={Login} />
          <Route path="/platform/signup" component={Signup} /> */}
        </Grid>

      </Grid>

    );
  }
}

LoginSignupWrapper.propTypes = {
  signup: PropTypes.func.isRequired,
};

const styles = () => ({
  logo: {
    maxHeight: 100,
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  containerGrid: {
    height: 'calc(100vh)',
  },
  imageContainerGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
    // background: 'linear-gradient(45deg, #942463, #68328a)',
    height: '100%',
    width: '100%',
  },
});

export default withStyles(styles)(LoginSignupWrapper);



// WEBPACK FOOTER //
// ./src/app/platform-startscreen/loginSignupWrapper.js